import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import RenderIf from '../../../shared/render-if/components/render-if';
import DefaultLoader from '../../../shared/default-loader/components/default-loader';
import WithdrawalForm from './withdrawal-form';
import PageHeader from '../../../shared/page-header/components/page-header';
import EmptyState from '../../../shared/empty-state/components/empty-state';
import PaymentMethodModal from '../../payment-methods/components/payment-method-modal';
import AddPaymentMethodModal from '../../payment-methods/components/add-payment-method-modal';
import paymentMethodsConstants from '../../payment-methods/constants/payment-methods-constants';
import constants from '../../../../common/constants';
import { getUserPaymentMethods, getPaymentMethodTypes, togglePaymentMethodModal } from '../../payment-methods/actions/payment-method-actions';

import '../styles/withdrawals.css';

class Withdrawals extends Component {
  componentDidMount() {
    const { getUserPaymentMethods } = this.props;

    getUserPaymentMethods(paymentMethodsConstants.statuses.approved.code, null, constants.payment_method_types.bank.id);
  }

  showPaymentMethodModal() {
    const { togglePaymentMethodModal, getPaymentMethodTypes } = this.props;

    getPaymentMethodTypes(true);
    togglePaymentMethodModal(true);
  }

  render() {
    const { userBalance, paymentMethods, httpInProgress, showPaymentMethodModal, paymentMethodTypes, showAddPaymentMethodModal, selectedPaymentMethodType } = this.props;
    const { t } = this.context;
    const balance = userBalance && userBalance.balance ? userBalance.balance : 0;

    return (
      <div className="withdrawals-container">
        <RenderIf if={showPaymentMethodModal && paymentMethodTypes && paymentMethodTypes.length > 0}>
          <PaymentMethodModal />
        </RenderIf>
        <RenderIf if={showAddPaymentMethodModal && selectedPaymentMethodType && paymentMethodTypes && paymentMethodTypes.length > 0}>
          <AddPaymentMethodModal />
        </RenderIf>
        <PageHeader title={'WITHDRAWALS.TITLE'} />
        <RenderIf if={!httpInProgress && userBalance && paymentMethods && paymentMethods.length > 0}>
          <div className="row">
            <div className="col-md-12 text-center">
              <p className="withdrawals-container__balance">
                <span className="balance-title">{t('WITHDRAWALS.WITHDRAWABLE_AMOUNT')}</span>{' '}
                <span className={`balance-value ${balance > 0 ? 'util-color-green' : 'util-color-red'}`}>${parseFloat(balance).toFixed(2)}</span>
              </p>
            </div>
            <div className="col-md-12">
              <WithdrawalForm />
            </div>
          </div>
        </RenderIf>
        <RenderIf if={!httpInProgress && paymentMethods && paymentMethods.length === 0}>
          <EmptyState title={'WITHDRAWAL.NO_APPROVED_PAYMENT_METHODS'} actionButtonLabel={'PAYMENT_METHODS.ADD_METHOD_BTN'} callback={this.showPaymentMethodModal.bind(this)} />
        </RenderIf>
        <RenderIf if={httpInProgress}>
          <div className="display-flex-center screen-height">
            <DefaultLoader />
          </div>
        </RenderIf>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userBalance: state.paymentsReducer.userBalance,
  paymentMethods: state.paymentMethodsReducer.paymentMethods,
  paymentMethodTypes: state.paymentMethodsReducer.paymentMethodTypes,
  showPaymentMethodModal: state.paymentMethodsReducer.showPaymentMethodModal,
  showAddPaymentMethodModal: state.paymentMethodsReducer.showAddPaymentMethodModal,
  selectedPaymentMethodType: state.paymentMethodsReducer.selectedPaymentMethodType,
  httpInProgress: state.httpInProgressReducer.httpInProgress,
});

const mapDispatchToProps = dispatch => ({
  getUserPaymentMethods: (status, provider, type) => {
    dispatch(getUserPaymentMethods(status, provider, type));
  },
  togglePaymentMethodModal: show => {
    dispatch(togglePaymentMethodModal(show));
  },
  getPaymentMethodTypes: active => {
    dispatch(getPaymentMethodTypes(active));
  },
});

Withdrawals.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Withdrawals);



// WEBPACK FOOTER //
// ./src/app/main/withdrawals/components/withdrawals.js